<template>
  <div style="padding:0; position:relative; height:100%; width:100%; flex:1;">
    <div class="outer-new-request-panel">
    <div class="new-request-panel" style="position:absolute; top:24px; z-index:10; width:420px;">
      <div class="new-request-panel-content">
        <div class="new-request-head">
          <el-scrollbar max-height="220px">
            <template v-for="(location, index) in formInputs.locations" :key="index">
              <el-row
                class="new-request-location-row-breather__minimal"
                v-if="index == 0"
              ></el-row>
              <el-row>
                <el-col :span="2"
                  ><el-icon
                    size="small"
                    class="new-request-location-icon"
                    style="display: none"
                    :class="{
                      'new-request-pickup-location-icon': isNewLocationPickupIcon(index),
                      'new-request-delivery-location-icon': isNewLocationDeliveryIcon(index),
                    }"
                    ><MapLocation /></el-icon
                ></el-col>
                <el-col :span="20"
                  ><MapAutocompleteInput
                    :placeholder="setPlaceHolderName(index)"
                    @place_changed="setPlace($event, index)"
                    :input-class="'request-stop'"
                    :options="autocompleteOptions"
                    v-model="location.name"
                  />
                </el-col>
                <el-col :span="2" v-show="displayDeleteIcon(index)">
                  <el-tooltip content="Delete this location" placement="top">
                    <el-icon
                      size="small"
                      @click="removeLocation(index)"
                      class="new-request-location-icon new-request-location-icon__actionable"
                      ><Delete /></el-icon
                  ></el-tooltip>
                </el-col>
              </el-row>
              <el-row class="new-request-location-row-breather"></el-row>
            </template>

            <div v-if="allowNewLocation">
              <el-row>
                <el-col :span="2"></el-col>
                <el-col :span="20">
                  <span class="new-request-add-destination-button" @click="addNewDestination">
                    <a class="add-destination"> <strong> + </strong> Add Destination</a>
                  </span>
                </el-col>
                <el-col :span="2"></el-col>
              </el-row>
            </div>
          </el-scrollbar>
        </div>
        <el-divider />

        <Transition name="panel-slide">
        <div class="new-request-body-section">
          <div v-if="showMinimisedBody">
            <el-row v-if="isValidForm">
              <el-col :span="2"></el-col>
              <el-col :span="20">
                <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="The bubble indicates the total number of locations"
                  placement="top"
                  v-if="formInputs.locations.length > 5"
                >
                  <el-badge :value="formInputs.locations.length" class="item" type="success">
                    <el-button
                      type="primary"
                      @click="getPriceQuote"
                      class="new-request-full-button"
                      size="large"
                      v-loading="loading"
                    >
                      Get Price Quotes
                    </el-button>
                  </el-badge>
                </el-tooltip>
                <el-button
                  type="primary"
                  @click="getPriceQuote"
                  class="new-request-full-button"
                  size="large"
                  v-loading="loading"
                  v-else
                >
                  {{ loading ? 'Getting prices...' : 'Get Price Quotes' }}
                </el-button>
              </el-col>
              <el-col :span="2"></el-col>
            </el-row>
            <el-row v-else>
              <el-col :span="2"></el-col>
              <el-col :span="20">
                <el-button type="primary" @click="" class="new-request-full-button" size="large" disabled>
                  Get Price Quotes
                </el-button>
              </el-col>
              <el-col :span="2"></el-col>
            </el-row>
          </div>
          <div v-else>
            <el-row>
              <el-col :span="2"></el-col>
              <el-col :span="20"><p class="cargo-size-heading"></p></el-col>
              <el-col :span="2"></el-col>
            </el-row>
            <el-row>
              <el-col :span="2"></el-col>
              <el-col :span="20">
                <div class="new-request-vendors-panel">
                  <el-tabs
                    v-model="activeCargoSizeHeaderName"
                    class="demo-tabs"
                    @tab-click="handleCargoSizeTab"
                    :stretch="tabsStretchSettings"
                  >
                    <el-tab-pane label="Small" name="first" v-if="hasSmallVendors">
                      <div
                        v-for="item in smallVendors"
                        class="request-vendor-row"
                        :class="{ 'request-vendor-row__active': isActiveRow(item.vehicle_type_id) }"
                        @click="setActiveVendor(item.vehicle_name, item.vehicle_type_id)"
                      >
                        <el-row>
                          <el-col :span="8"><el-icon size="large" class="request-vendor-row-icon"><Bicycle /></el-icon></el-col>
                          <el-col :span="8"><span class="request-vendor-row-label"><p>{{ item.vehicle_name }}</p></span></el-col>
                          <el-col :span="8"><span class="request-vendor-row-amount"><p>KES {{ item.cost.toLocaleString() }}</p></span></el-col>
                        </el-row>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane label="Medium" name="second" v-if="hasMediumVendors">
                      <div
                        class="request-vendor-row"
                        :class="{ 'request-vendor-row__active': isActiveRow(item.vehicle_type_id) }"
                        @click="setActiveVendor(item.vehicle_name, item.vehicle_type_id)"
                        v-for="item in mediumVendors"
                      >
                        <el-row>
                          <el-col :span="8"><el-icon size="large" class="request-vendor-row-icon"><Van /></el-icon></el-col>
                          <el-col :span="8"><span class="request-vendor-row-label"><p>{{ item.vehicle_name }}</p></span></el-col>
                          <el-col :span="8"><span class="request-vendor-row-amount"><p>KES {{ item.cost.toLocaleString() }}</p></span></el-col>
                        </el-row>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane label="Large" name="third" v-if="hasLargeVendors">
                      <div
                        class="request-vendor-row"
                        :class="{ 'request-vendor-row__active': isActiveRow(item.vehicle_type_id) }"
                        @click="setActiveVendor(item.vehicle_name, item.vehicle_type_id)"
                        v-for="item in largeVendors"
                      >
                        <el-row>
                          <el-col :span="8"><el-icon size="large" class="request-vendor-row-icon"><Van /></el-icon></el-col>
                          <el-col :span="8"><span class="request-vendor-row-label"><p>{{ item.vehicle_name }}</p></span></el-col>
                          <el-col :span="8"><span class="request-vendor-row-amount"><p>KES {{ item.cost.toLocaleString() }}</p></span></el-col>
                        </el-row>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </el-col>
              <el-col :span="2"></el-col>
            </el-row>
            <el-row>
              <el-col :span="2"></el-col>
              <el-col :span="20">
                <el-tabs
                  v-model="activeRequestActionHeaderName"
                  class="demo-tabs"
                  @tab-click="handleRequestActionTab"
                  :stretch="tabsStretchSettings"
                >
                  <el-tab-pane label="Notes" name="firstAction">
                    <div>
                      <el-input
                        v-model="formNotes"
                        type="textarea"
                        size="large"
                        placeholder="Type your notes here"
                        class="request-form-notes"
                      />
                    </div>
                    <div style="margin: 5px 0" />
                  </el-tab-pane>
                  <el-tab-pane label="Manifest" name="thirdAction">
                    <div>
                      <el-input
                        v-model="formManifestNumber"
                        type="input"
                        size="large"
                        placeholder="Record the manifest number"
                        class="request-form-notes"
                      />
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="Schedule" name="secondAction">
                    <div class="block">
                      <el-date-picker
                        v-model="formScheduledDate"
                        type="datetime"
                        placeholder="📅  Pick-up date and time"
                        :default-time="defaultTime"
                        size="large"
                        class="request-form-schedule-date"
                        :disabled-date="disableScheduleDate"
                        style="width:100%"
                      />
                      <div style="margin: 5px 0" />
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </el-col>
              <el-col :span="2"></el-col>
            </el-row>
            <el-row>
              <el-col :span="2"></el-col>
              <el-col :span="20">
                <div style="margin: 10px 0" />
                <div>
                  <el-button
                    type="primary"
                    @click="placeOrder"
                    class="new-request-full-button"
                    size="large"
                    :disabled="!formActiveVendor || orderRequestInProgress"
                    v-loading="order_loading"
                  >
                    Place {{ formActiveVendor }} Order
                  </el-button>
                </div>
              </el-col>
              <el-col :span="2"></el-col>
            </el-row>
          </div>
        </div>
        </Transition>
      </div>
    </div>
    </div><!-- /outer-new-request-panel -->


 <!-- Floating action buttons — bottom right -->
    <div class="track-fab-group">
     
      <button class="track-fab track-fab--purple" @click="router.push('/transactions/orders')">
  <svg 
    width="18" 
    height="18" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    stroke-width="2" 
    stroke-linecap="round" 
    stroke-linejoin="round" 
    style="margin-right: 8px; vertical-align: text-bottom;"
  >
    <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1-2-1Z" />
    <line x1="16" y1="8" x2="8" y2="8" />
    <line x1="16" y1="12" x2="8" y2="12" />
    <line x1="10" y1="16" x2="8" y2="16" />
  </svg>
  Order History
</button>
    </div>

    <GMapMap
      :center="mapCenter"
      :zoom="14"
      map-type-id="roadmap"
      :options="mapOptions"
      style="position:absolute; top:0; left:0; right:0; bottom:0; width:100%; height:100%;"
      ref="myMapRef"
    >
      <GMapMarker
        :key="index"
        v-for="(m, index) in formMarkers"
        :position="m.position"
        :clickable="false"
        :draggable="false"
        :icon="getMarkerIcon(index)"
      />
      <GMapPolyline
        v-if="routePath.length > 1"
        :path="routePath"
        :options="polylineOptions"
      />
    </GMapMap>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref, reactive, watch, nextTick } from "vue";
import router from "../../router";
import {
  MapLocation,
  AddLocation,
  Van,
  Bicycle,
  Postcard,
  Delete,
  Edit,
} from "@element-plus/icons-vue";
import type { TabsPaneContext } from "element-plus";
import { ElMessage } from "element-plus";
declare const google: any;
import axios from "axios";
import { DateTime } from "luxon";
import { useAuthStore } from "../../store/authStore";
import MapAutocompleteInput from "./MapAutocompleteInput.vue";

const store = useAuthStore();
const token = localStorage.getItem("_panda");
axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

const defaultTime = new Date(2000, 1, 1, 12, 0, 0);

const tabsStretchSettings = ref(true);
const isValidForm = ref(false);
const loading = ref(false);
const order_loading = ref(false);
const showMinimisedBody = ref(true);

const maxDeliveryLocations = ref(5);
const activeRowIndex = ref(1000);
const formActiveVendor = ref("");
const formNotes = ref("");
const formManifestNumber = ref("");
const formScheduledDate = ref("");
const myMapRef = ref<any>(null);
const routePath = ref<{ lat: number; lng: number }[]>([]);
const activeCargoSizeHeaderName = ref("first");
const activeRequestActionHeaderName = ref("firstAction");
const pricingResponse = reactive({ data: <any>null });
const smallVendors = ref<vendorQuote[]>([]);
const mediumVendors = ref<vendorQuote[]>([]);
const largeVendors = ref<vendorQuote[]>([]);
const orderRequestInProgress = ref(false);

interface googleLocation {
  name: string;
  formatted_address?: string;
  lat: number;
  lng: number;
  place_id: string;
  key: number;
}

interface formStruct {
  locations: googleLocation[];
}

interface markerStruct {
  position: { lat: number; lng: number };
}

interface vendorQuote {
  vehicle_name: string;
  vehicle_type_id: number;
  cost: number;
  vehicle_size: string;
}

const formMarkers = reactive<markerStruct[]>([]);

const mapCenter = reactive<googleLocation>({
  name: "",
  key: 0,
  lat: -1.26723,
  lng: 36.81026,
  place_id: "",
});

const formInputs = reactive<formStruct>({
  locations: [
    { name: "", formatted_address: "", key: 0, lat: 0, lng: 0, place_id: "" },
    { name: "", formatted_address: "", key: 1, lat: 0, lng: 0, place_id: "" },
  ],
});

const removeLocation = (index: number) => {
  formInputs.locations.splice(index, 1);
  removeMarker(index);
  occasionalFormValidityCheck();
  showMinimisedBody.value = true;
};

const removeMarker = (index: number) => {
  formMarkers.splice(index, 1);
};

const isActiveRow = (index: number) => {
  return index == activeRowIndex.value;
};

const setActiveVendor = (name: string, index: number) => {
  activeRowIndex.value = index;
  formActiveVendor.value = name;
};

const setPlace = async (details: any, index: number) => {
  try {
    const placeName = details.name || "";
    const formattedAddress = details.formatted_address || "";
    
    // Combine name and formatted_address into name for backend
    // This ensures backend stores the combined value, so we can just display name
    let combinedName = placeName;
    if (placeName && formattedAddress && placeName !== formattedAddress) {
      combinedName = `${placeName}; ${formattedAddress}`;
    } else if (formattedAddress && !placeName) {
      combinedName = formattedAddress;
    }
    
    let location = {
      lat: details.geometry.location.lat(),
      lng: details.geometry.location.lng(),
      key: Date.now(),
      name: combinedName, // Combined name for backend
      formatted_address: formattedAddress, // Keep separate for backend reference
      place_id: details.place_id,
    };
    formInputs.locations.splice(index, 1, location);
    addMarker(location, index);
    await nextTick();
    occasionalFormValidityCheck();
    showMinimisedBody.value = true;
  } catch (er) {
    ElMessage({ message: "Failed to add the location, please retry", type: "error" });
  }
};

const addMarker = (location: any, index: number) => {
  let { lat, lng } = location;
  formMarkers.splice(index, 1, { position: { lat, lng } });
};

const fetchDirectionsRoute = async () => {
  if (formMarkers.length < 2) { routePath.value = []; return; }
  try {
    const directionsService = new google.maps.DirectionsService();
    const waypoints = formMarkers.slice(1, -1).map((m: any) => ({
      location: m.position,
      stopover: true,
    }));
    const result = await directionsService.route({
      origin: formMarkers[0].position,
      destination: formMarkers[formMarkers.length - 1].position,
      waypoints,
      travelMode: google.maps.TravelMode.DRIVING,
      optimizeWaypoints: false,
    });
    // Decode all legs into a single flat path
    const path: { lat: number; lng: number }[] = [];
    result.routes[0].legs.forEach((leg: any) => {
      leg.steps.forEach((step: any) => {
        step.path.forEach((pt: any) => {
          path.push({ lat: pt.lat(), lng: pt.lng() });
        });
      });
    });
    routePath.value = path;
  } catch (e) {
    // Fallback to straight line if directions fail
    routePath.value = formMarkers.map((m: any) => m.position);
  }
};

const updateBounds = () => {
  fetchDirectionsRoute();
  const mapInstance = myMapRef.value;
  try {
    if (mapInstance) {
      mapInstance.$mapPromise.then((map: any) => {
        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < formMarkers.length; i++) {
          bounds.extend(formMarkers[i].position);
        }
        map.fitBounds(bounds, { left: 440, top: 40, right: 40, bottom: 40 });
      });
    } else {
      ElMessage({ message: "Failed to resize the map", type: "error" });
    }
  } catch (er) {
    console.log(er);
  }
};

const addNewDestination = () => {
  formInputs.locations.push({
    name: "",
    formatted_address: "",
    key: Date.now(),
    lat: 0,
    lng: 0,
    place_id: "",
  });
  occasionalFormValidityCheck();
};

const getLocationDisplayText = (location: googleLocation): string => {
  // name already includes formatted_address details (combined when setting place)
  // So we just need to return name from backend
  return location.name || "";
};

const disableScheduleDate = (date: any) => {
  const today = new Date();
  return date < today;
};

const occasionalFormValidityCheck = () => {
  let emptyLocations = [];
  for (let i = 0; i < formInputs.locations.length; i++) {
    // A location is valid if it has a name (which now includes all details)
    if (formInputs.locations[i].name == "") {
      emptyLocations.push(i);
    }
  }
  if (emptyLocations.length > 0) {
    isValidForm.value = false;
    showMinimisedBody.value = true;
  } else {
    isValidForm.value = true;
  }
  updateBounds();
};

const handleCargoSizeTab = (tab: TabsPaneContext, event: Event) => {};
const handleRequestActionTab = (tab: TabsPaneContext, event: Event) => {};

const autocompleteOptions: any = {
  componentRestrictions: { country: "ke" },
  fields: ["geometry", "name", "place_id", "formatted_address", "address_components", "types"],
};

const isNewLocationPickupIcon = (index: number) => index == 0;
const isNewLocationDeliveryIcon = (index: number) => index != 0;

const setPlaceHolderName = (index: number) => {
  if (index == 0) return "Pick-up address";
  return "Drop-off address";
};

const displayDeleteIcon = (index: number) => {
  if (index < 2) return false;
  return true;
};

const allowNewLocation = computed(() => {
  return formInputs.locations.length < maxDeliveryLocations.value && isValidForm.value;
});

const getXVendors = (size: string) => {
  return pricingResponse.data.quotes.filter((quote: any) => quote.vehicle_size === size);
};

const hasSmallVendors = computed(() => {
  return pricingResponse.data.quotes.some((element: any) => element.vehicle_size == "small");
});

const hasMediumVendors = computed(() => {
  return pricingResponse.data.quotes.some((element: any) => element.vehicle_size == "medium");
});

const hasLargeVendors = computed(() => {
  return pricingResponse.data.quotes.some((element: any) => element.vehicle_size == "large");
});

const getPriceQuote = async () => {
  loading.value = true;
  try {
    const response = await axios.post(
      `${import.meta.env.VITE_PRICING_SERVICE}customerPriceCheck`,
      {
        company_id: store.getUserData.company_id,
        user_id: store.getUserData.user_id,
        locations: formInputs.locations,
      }
    );
    if (response.status == 200) {
      if (response.data.status) {
        showMinimisedBody.value = false;
        pricingResponse.data = response.data.data;
        smallVendors.value = getXVendors("small");
        mediumVendors.value = getXVendors("medium");
        largeVendors.value = getXVendors("large");
      } else {
        ElMessage({ message: "response.data.message 1", type: "error" });
      }
    } else {
      ElMessage({ message: "response.data.message 2", type: "error" });
    }
    loading.value = false;
  } catch (er) {
    console.log(er);
    loading.value = false;
    ElMessage({ message: "Something went wrong 3", type: "error" });
  }
};

const placeOrder = async () => {
  if (orderRequestInProgress.value) {
    ElMessage({ message: "Order is already being placed. Please wait...", type: "info" });
    return;
  }
  orderRequestInProgress.value = true;
  order_loading.value = true;
  let scheduled_time = getScheduledTime();
  try {
    const response = await axios.post(
      `${import.meta.env.VITE_ORDERS_SERVICE}createOrder`,
      {
        token: store.getToken,
        company_id: store.getUserData.company_id,
        user_id: store.getUserData.user_id,
        pricing_uuid: pricingResponse.data.uuid,
        vehicle_type: activeRowIndex.value,
        payment_plan: 1,
        payment_method: 1,
        source: "web",
        scheduled_time: scheduled_time,
        notes: formNotes.value,
        manifest: formManifestNumber.value,
      }
    );
    if (response.status == 200) {
      if (response.data.status) {
        const { tracking_token, order_number } = response.data.data;
        const trackQuery = tracking_token
          ? `?token=${tracking_token}`
          : `?order=${order_number}`;
        router.push(`/track${trackQuery}`);
      } else {
        ElMessage({ message: response.data.message, type: "error" });
        order_loading.value = false;
      }
    } else {
      ElMessage({ message: response.data.message, type: "error" });
      order_loading.value = false;
    }
  } catch (er) {
    console.log(er);
    order_loading.value = false;
    ElMessage({ message: "Something went wrong", type: "error" });
  } finally {
    order_loading.value = false;
    orderRequestInProgress.value = false;
  }
};

const logwat = () => {
  store.setAuthStatus(false);
  store.$reset();
  localStorage.removeItem("_panda");
  router.push("/login");
};

const mapOptions = {
  styles: [
    { elementType: "geometry", stylers: [{ color: "#eaf0fb" }] },
    { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#3d4a5c" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#ffffff" }] },
    { featureType: "administrative", elementType: "geometry", stylers: [{ visibility: "off" }] },
    { featureType: "administrative.land_parcel", elementType: "labels", stylers: [{ visibility: "off" }] },
    { featureType: "poi", stylers: [{ visibility: "off" }] },
    { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#c8e6c9" }] },
    { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#388e3c" }] },
    { featureType: "road", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
    { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#dce6f5" }] },
    { featureType: "road", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
    { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#b8cef5" }] },
    { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#9ab8e8" }] },
    { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#12284A" }] },
    { featureType: "road.local", stylers: [{ visibility: "simplified" }] },
    { featureType: "transit", stylers: [{ visibility: "off" }] },
    { featureType: "water", elementType: "geometry", stylers: [{ color: "#a8cce0" }] },
    { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#3d6b8a" }] },
  ],
  disableDefaultUI: true,
  zoomControl: false,
};

const MARKER_COLORS = ['#22c55e', '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4'];

const polylineOptions = {
  strokeColor: "#2563eb",
  strokeOpacity: 1.0,
  strokeWeight: 5,
  geodesic: true,
};

const getMarkerIcon = (index: number) => {
  const color = MARKER_COLORS[index % MARKER_COLORS.length];
  const label = String.fromCharCode(65 + index);
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="44" viewBox="0 0 36 44">
      <filter id="shadow${index}" x="-30%" y="-30%" width="160%" height="160%">
        <feDropShadow dx="0" dy="2" stdDeviation="2" flood-color="rgba(0,0,0,0.25)"/>
      </filter>
      <ellipse cx="18" cy="42" rx="6" ry="2.5" fill="rgba(0,0,0,0.12)"/>
      <path d="M18 2C10.268 2 4 8.268 4 16c0 10 14 26 14 26s14-16 14-26C32 8.268 25.732 2 18 2z" fill="${color}" filter="url(#shadow${index})"/>
      <circle cx="18" cy="16" r="8" fill="white" opacity="0.92"/>
      <text x="18" y="20" text-anchor="middle" font-size="9" font-weight="700" font-family="DM Sans, sans-serif" fill="${color}">${label}</text>
    </svg>`;
  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
    scaledSize: { width: 36, height: 44 },
    anchor: { x: 18, y: 44 },
  };
};

const getScheduledTime = () => {
  let current_time = DateTime.now().toFormat("yyyy-MM-dd HH:mm:ss");
  if (formScheduledDate.value == "") {
    return current_time;
  } else {
    let selected_time = DateTime.fromJSDate(new Date(formScheduledDate.value));
    if (selected_time < current_time) {
      return current_time;
    }
    return selected_time.toFormat("yyyy-MM-dd HH:mm:ss");
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&display=swap');

.ep-main, .el-main {
  padding: 0 !important;
  position: relative;
  height: 100%;
  width: 100%;
  flex: 1;
  font-family: 'DM Sans', sans-serif;
}

/* ── Outer container ──────────────────────── */
.outer-new-request-panel {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  /*max-width: 1280px; */
  margin: 0 auto;
  padding: 0 30px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  pointer-events: none;
  z-index: 10;
}

/* ── Panel ────────────────────────────────── */
.new-request-panel {
  position: absolute;
  top: 24px;
  width: 420px;
  max-height: calc(100vh - 110px);
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 8px 40px rgba(18,40,74,0.16), 0 2px 8px rgba(18,40,74,0.08);
  z-index: 10;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  pointer-events: all;
  transition: max-height 0.35s cubic-bezier(0.4,0,0.2,1);
}
.new-request-panel::-webkit-scrollbar { display: none; }
.new-request-panel-content { padding: 0; }

/* ── Panel header section (locations) ────── */
.new-request-head {
  background: linear-gradient(135deg, #12284A 0%, #1e3f73 100%);
  padding: 26px 4px;
  border-radius: 16px 16px 0 0;
}

/* ── Panel body ───────────────────────────── */
.new-request-body-section {
  padding: 10px 9px 35px;
  background: #f8fafc;
}

/* ── Panel expand/collapse transition ─────── */
.panel-slide-enter-active, .panel-slide-leave-active {
  transition: all 0.32s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}
.panel-slide-enter-from, .panel-slide-leave-to {
  opacity: 0; max-height: 0; transform: translateY(-6px);
}
.panel-slide-enter-to, .panel-slide-leave-from {
  opacity: 1; max-height: 600px; transform: translateY(0);
}

/* ── Location inputs ──────────────────────── */
.request-stop {
  width: 100%;
  height: 40px;
  border-radius: 8px;
  border: 1.5px solid rgba(255,255,255,0.2);
  background: rgba(255,255,255,0.1);
  color: #ffffff;
  padding: 0 10px;
  font-family: 'DM Sans', sans-serif;
  font-size: 0.84rem;
  outline: none;
  transition: border-color 0.15s, background 0.15s;
  box-sizing: border-box;
}
.request-stop::placeholder { color: rgba(255,255,255,0.45); }
.request-stop:focus {
  border-color: rgba(255,255,255,0.55);
  background: rgba(255,255,255,0.16);
  outline: none;
}

.new-request-location-icon {
  height: -webkit-fill-available;
  color: rgba(255,255,255,0.45);
}

.new-request-location-icon__actionable {
  cursor: pointer;
  color: rgba(255, 255, 255, 0.45);
  background: rgba(255,255,255,0.08);
  border-radius: 50%;
  width: 26px; height: 26px;
  display: flex; align-items: center; justify-content: center;
  margin: auto;
  transition: background 0.15s, color 0.15s;
  margin-top: 7px;
}
.new-request-location-icon__actionable:hover {
  color: #ff6b6b;
  background: rgba(255, 100, 100, 0.15);
}

.new-request-location-row-breather { margin: 6px 0; }
.new-request-location-row-breather__minimal { margin: 4px; }

.new-request-add-destination-button { float: left; cursor: pointer; }
.add-destination {
  color: rgba(255,255,255,0.75);
  font-weight: 500; font-size: 0.8rem;
  text-decoration: none;
  display: flex; align-items: center; gap: 6px;
  padding: 4px 0;
  transition: color 0.15s;
}
.add-destination:hover { color: white; }
.new-request-pickup-location-icon { color: rgba(255,255,255,0.6); }
.new-request-delivery-location-icon { color: #86efac; }

/* ── Divider ──────────────────────────────── */
:deep(.ep-divider), :deep(.el-divider) {
  margin: 0 !important;
  border-color: rgba(255,255,255,0.08) !important;
}

/* ── Get quotes / Place order buttons ────── */
.new-request-full-button {
  width: 100%;
  height: 42px !important;
  border-radius: 8px !important;
  font-family: 'DM Sans', sans-serif !important;
  font-size: 0.88rem !important;
  font-weight: 600 !important;
  background: rgba(255,255,255,0.14) !important;
  border: 1.5px solid rgba(255,255,255,0.28) !important;
  color: white !important;
  letter-spacing: 0.01em !important;
  transition: background 0.15s !important;
}
.new-request-full-button:hover { background: rgba(255,255,255,0.22) !important; }
:deep(.new-request-full-button .ep-loading-mask),
:deep(.new-request-full-button .el-loading-mask) {
  background: rgba(18,40,74,0.35) !important;
  border-radius: 8px !important;
}
:deep(.ep-loading-spinner .circular), :deep(.el-loading-spinner .circular) {
  width: 20px !important; height: 20px !important;
}
:deep(.ep-loading-spinner .path), :deep(.el-loading-spinner .path) {
  stroke: white !important; stroke-width: 3 !important;
}

/* ── Tabs ─────────────────────────────────── */
:deep(.ep-tabs__header), :deep(.el-tabs__header) { margin-bottom: 10px !important; }
:deep(.ep-tabs__item), :deep(.el-tabs__item) {
  font-family: 'DM Sans', sans-serif !important;
  font-size: 0.82rem !important; font-weight: 500 !important;
  color: #9ca3af !important; padding: 0 12px !important;
}
:deep(.ep-tabs__item.is-active), :deep(.el-tabs__item.is-active) { color: #12284A !important; }
:deep(.ep-tabs__active-bar), :deep(.el-tabs__active-bar) { background-color: #12284A !important; }
:deep(.ep-tabs__nav-wrap::after), :deep(.el-tabs__nav-wrap::after) {
  background-color: #e5e7eb !important; height: 1px !important;
}

/* ── Vendor rows ──────────────────────────── */
.new-request-vendors-panel { margin-bottom: 4px; }
.request-vendor-row {
  display: flex; align-items: center; justify-content: space-between;
  padding: 10px 14px;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  cursor: pointer; margin-bottom: 6px;
  transition: border-color 0.15s, background 0.1s, box-shadow 0.15s;
  background: white;
}
.request-vendor-row:hover {
  border-color: #12284A; background: #f8fafc;
  box-shadow: 0 2px 8px rgba(18,40,74,0.08);
}
.request-vendor-row__active {
  border-color: #12284A !important;
  background: linear-gradient(135deg, #eef2f8 0%, #e8eef7 100%) !important;
  box-shadow: 0 2px 10px rgba(18,40,74,0.1) !important;
}
.request-vendor-row :deep(.ep-row), .request-vendor-row :deep(.el-row) { width: 100%; align-items: center; }
.request-vendor-row div { height: auto !important; }
.request-vendor-row-icon { display: flex; align-items: center; color: #6b7280; }
.request-vendor-row-label { font-size: 0.84rem; font-weight: 500; color: #374151; text-align: center; }
.request-vendor-row-label p { margin: 0; padding: 0; }
.request-vendor-row-amount { font-size: 0.84rem; font-weight: 700; color: #12284A; text-align: right; }
.request-vendor-row-amount p { margin: 0; padding: 0; }

/* ── Notes / Manifest / Schedule ─────────── */
.cargo-size-heading {
  font-size: 0.68rem; color: #9ca3af; margin: 0;
  text-transform: uppercase; letter-spacing: 0.05em;
}
.request-form-notes { width: 100%; }
:deep(.request-form-notes .ep-textarea__inner),
:deep(.request-form-notes .el-textarea__inner) {
  border-radius: 10px !important; border: 1.5px solid #e5e7eb !important;
  font-family: 'DM Sans', sans-serif !important; font-size: 0.84rem !important;
  color: #374151 !important; background: white !important;
  padding: 10px 12px !important; resize: none; box-shadow: none !important;
  transition: border-color 0.15s !important;
}
:deep(.request-form-notes .ep-textarea__inner:focus),
:deep(.request-form-notes .el-textarea__inner:focus) { border-color: #12284A !important; }
:deep(.request-form-notes .ep-input__wrapper),
:deep(.request-form-notes .el-input__wrapper) {
  border-radius: 10px !important; border: 1.5px solid #e5e7eb !important;
  background: white !important; box-shadow: none !important;
  padding: 0 12px !important; height: 42px !important;
}
:deep(.request-form-notes .ep-input__wrapper:focus-within),
:deep(.request-form-notes .el-input__wrapper:focus-within) {
  border-color: #12284A !important; box-shadow: none !important;
}
:deep(.request-form-notes .ep-input__inner),
:deep(.request-form-notes .el-input__inner) {
  font-family: 'DM Sans', sans-serif !important; font-size: 0.84rem !important; color: #374151 !important;
}

.request-form-schedule-label {
  display: block; font-size: 0.75rem; font-weight: 600; color: #6b7280;
  text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 8px;
}
.request-form-schedule-date { width: 100%; }
:deep(.request-form-schedule-date .ep-input__wrapper),
:deep(.request-form-schedule-date .el-input__wrapper),
:deep(.request-form-schedule-date .ep-input__wrapper:focus-within),
:deep(.request-form-schedule-date .el-input__wrapper:focus-within),
:deep(.request-form-schedule-date .ep-input__wrapper.is-focus),
:deep(.request-form-schedule-date .el-input__wrapper.is-focus) {
  border-radius: 10px !important;
  border: 1.5px solid #e5e7eb !important;
  background: white !important;
  box-shadow: none !important;
  outline: none !important;
  height: 42px !important;
  font-family: 'DM Sans', sans-serif !important;
}
:deep(.request-form-schedule-date .ep-input__prefix-inner),
:deep(.request-form-schedule-date .el-input__prefix-inner) { color: #9ca3af !important; }
:deep(.request-form-schedule-date .ep-input__inner),
:deep(.request-form-schedule-date .el-input__inner) {
  font-family: 'DM Sans', sans-serif !important;
  font-size: 0.84rem !important;
  color: #374151 !important;
}

/* ── Place order button ───────────────────── */
:deep(.ep-button--primary), :deep(.el-button--primary) {
  background: linear-gradient(135deg, #12284A 0%, #1e3f73 100%) !important;
  border-color: transparent !important; font-weight: 600 !important;
  letter-spacing: 0.01em !important; height: 44px !important;
  border-radius: 10px !important; font-family: 'DM Sans', sans-serif !important;
  width: 100% !important;
}
:deep(.ep-button--primary:hover), :deep(.el-button--primary:hover) {
  background: linear-gradient(135deg, #1a3a6a 0%, #2a5299 100%) !important;
}
/* ── Floating action buttons ──────────────── */
.track-fab-group {
  position: absolute;
  bottom: 100px;
  right: 32px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 10;
  pointer-events: all;
}
.track-fab {
  height: 44px;
  padding: 0 22px;
  border-radius: 22px;
  font-family: 'DM Sans', sans-serif;
  font-size: 0.84rem;
  font-weight: 700;
  cursor: pointer;
  border: none;
  transition: all 0.18s cubic-bezier(0.4,0,0.2,1);
  letter-spacing: 0.02em;
  white-space: nowrap;
  box-shadow: 0 4px 16px rgba(0,0,0,0.15), 0 1.5px 4px rgba(0,0,0,0.08);
  width:200px;
}
.track-fab:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0,0,0,0.2), 0 2px 6px rgba(0,0,0,0.1);
}
.track-fab:active { transform: translateY(0); }
.track-fab--green {
  background: linear-gradient(135deg, #16a34a 0%, #22c55e 100%);
  color: white;
}
.track-fab--purple {
  background: linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%);
  color: white;
}
</style>